export default {
    "name": "getTrafficInformation",
    "kind": "HoudiniQuery",
    "hash": "f63961f28bb5ebc711edf92c72d7f9c6ae4e2276e5a9651ce736571a26dc0040",

    "raw": `query getTrafficInformation($input: TrafficInformationInput!) {
  getTrafficInformation(input: $input) {
    listForSeo {
      count
      items {
        type
        description
        coordinates {
          lat
          lng
        }
      }
    }
    listForMap {
      count
      items {
        type
        description
        coordinates {
          lat
          lng
        }
        location
      }
    }
    nearbyCitiesHierarchies {
      label
      value
    }
    locationLocalizedHierarchies {
      locale
      hierarchy {
        label
        value
      }
    }
    cityHierarchy {
      label
      value
    }
  }
}`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "getTrafficInformation": {
                "type": "TrafficInformationSuccessResult",
                "keyRaw": "getTrafficInformation(input: $input)",

                "selection": {
                    "fields": {
                        "listForSeo": {
                            "type": "TrafficInformationList",
                            "keyRaw": "listForSeo",

                            "selection": {
                                "fields": {
                                    "count": {
                                        "type": "Int",
                                        "keyRaw": "count",
                                        "visible": true
                                    },

                                    "items": {
                                        "type": "TrafficInformation",
                                        "keyRaw": "items",

                                        "selection": {
                                            "fields": {
                                                "type": {
                                                    "type": "TrafficInformationType",
                                                    "keyRaw": "type",
                                                    "visible": true
                                                },

                                                "description": {
                                                    "type": "String",
                                                    "keyRaw": "description",
                                                    "nullable": true,
                                                    "visible": true
                                                },

                                                "coordinates": {
                                                    "type": "Coordinates",
                                                    "keyRaw": "coordinates",
                                                    "nullable": true,

                                                    "selection": {
                                                        "fields": {
                                                            "lat": {
                                                                "type": "Float",
                                                                "keyRaw": "lat",
                                                                "visible": true
                                                            },

                                                            "lng": {
                                                                "type": "Float",
                                                                "keyRaw": "lng",
                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "listForMap": {
                            "type": "TrafficInformationList",
                            "keyRaw": "listForMap",

                            "selection": {
                                "fields": {
                                    "count": {
                                        "type": "Int",
                                        "keyRaw": "count",
                                        "visible": true
                                    },

                                    "items": {
                                        "type": "TrafficInformation",
                                        "keyRaw": "items",

                                        "selection": {
                                            "fields": {
                                                "type": {
                                                    "type": "TrafficInformationType",
                                                    "keyRaw": "type",
                                                    "visible": true
                                                },

                                                "description": {
                                                    "type": "String",
                                                    "keyRaw": "description",
                                                    "nullable": true,
                                                    "visible": true
                                                },

                                                "coordinates": {
                                                    "type": "Coordinates",
                                                    "keyRaw": "coordinates",
                                                    "nullable": true,

                                                    "selection": {
                                                        "fields": {
                                                            "lat": {
                                                                "type": "Float",
                                                                "keyRaw": "lat",
                                                                "visible": true
                                                            },

                                                            "lng": {
                                                                "type": "Float",
                                                                "keyRaw": "lng",
                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                },

                                                "location": {
                                                    "type": "String",
                                                    "keyRaw": "location",
                                                    "nullable": true,
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "nearbyCitiesHierarchies": {
                            "type": "HierarchySegment",
                            "keyRaw": "nearbyCitiesHierarchies",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "label": {
                                        "type": "String",
                                        "keyRaw": "label",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "value": {
                                        "type": "String",
                                        "keyRaw": "value",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "locationLocalizedHierarchies": {
                            "type": "LocalizedHierarchy",
                            "keyRaw": "locationLocalizedHierarchies",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "locale": {
                                        "type": "String",
                                        "keyRaw": "locale",
                                        "visible": true
                                    },

                                    "hierarchy": {
                                        "type": "HierarchySegment",
                                        "keyRaw": "hierarchy",

                                        "selection": {
                                            "fields": {
                                                "label": {
                                                    "type": "String",
                                                    "keyRaw": "label",
                                                    "nullable": true,
                                                    "visible": true
                                                },

                                                "value": {
                                                    "type": "String",
                                                    "keyRaw": "value",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "cityHierarchy": {
                            "type": "HierarchySegment",
                            "keyRaw": "cityHierarchy",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "label": {
                                        "type": "String",
                                        "keyRaw": "label",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "value": {
                                        "type": "String",
                                        "keyRaw": "value",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "input": "TrafficInformationInput"
        },

        "types": {
            "CoordinatesInput": {
                "lat": "Float",
                "lng": "Float"
            },

            "AddressQuery": {
                "coordinates": "CoordinatesInput",
                "entityType": "AddressEntityType",
                "query": "String"
            },

            "CoordinateBoundsInput": {
                "northeast": "CoordinatesInput",
                "southwest": "CoordinatesInput"
            },

            "TrafficInformationInput": {
                "addressQuery": "AddressQuery",
                "bounds": "CoordinateBoundsInput"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "CacheOrNetwork",
    "partial": false
};

"HoudiniHash=68d1ef10152c33e10227575390ead360e38e44abd34a793c573396c23fcf4d0f";